import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import React from 'react'
import {useCurrencyFormatter} from '../../../../../../../../commons/hooks/currency'
import {getLabeledItemTicketPrice} from '../../../../../../../../commons/selectors/order'
import {TableRow} from '../../../../table-row'
import {ItemProps} from './index'

export const Item = ({item, t}: ItemProps) => {
  const {getFormattedMoney} = useCurrencyFormatter()
  const ticketPrice = getLabeledItemTicketPrice(item, t, getFormattedMoney)

  const columns = [
    {content: item.name, dataHook: DH.TICKET_NAME},
    {content: ticketPrice, dataHook: DH.TICKET_PRICE},
    {content: item.quantity, dataHook: DH.TICKET_QUANTITY},
    {
      content: getFormattedMoney(item.total),
      dataHook: DH.TICKET_TOTAL_PRICE,
    },
  ]

  return (
    <div data-hook={DH.ORDER_SUCCESS_SUMMARY_WRAPPER}>
      <TableRow
        config={{
          dataHook: DH.ORDER_SUCCESS_SUMMARY,
          itemKey: item.id,
          columns,
        }}
      />
    </div>
  )
}
